<template>
    <div class="d-flex flex-column align-left edit-title-form">
        <p class="edit-title">Add event date</p>
        <div class="date-container">
            <p class="choose-date">Choose Date*</p>
            <input
                ref="datepicker"
                data-provide="datepicker"
                id="date"
                v-model="eventDate"
                data-popup-id="date-popup"
                autocomplete="off"
                class="edit-form-control search-mobile-input datepicker-home main-text js-date-value js-key-submit"
                type="text"
                name="date"
                placeholder="Enter event date"
            />
        </div>
        <button class="save-title-btn" @click="updateDate">Save</button>
    </div>
</template>

<script>
    import axios from 'axios'
    import { notification } from '../../../helpers/notification'
    import moment from 'moment'

    export default {
        name: 'AddEventDate',
        props: {
            eventInfo: {
                type: Object
            }
        },
        data() {
            return {
                eventDate: '',
                datepickerOptions: {
                    format: 'D, MM dd',
                    language: 'en'
                }
            }
        },
        methods: {
            async updateDate() {
                try {
                    const response = await axios.put(
                        '/event/manage/update/' + this.eventInfo.id,
                        {
                            start: this.eventDate,
                            duration: this.eventInfo.duration
                        }
                    )
                    notification('success', 'Events date successfully updated')
                    if (response.status === 200) {
                        const newEventData = {
                            id: this.eventInfo.id,
                            start: this.eventDate,
                            start_time: this.eventInfo.start_time,
                            duration: this.eventInfo.duration
                        }
                        this.$emit('updateEventData', newEventData)
                    }
                    window.location.reload()
                } catch (err) {
                    this.serverErrMsg = `[${err.response?.status}] : ${err.response?.data?.message}`
                }
            }
        },
        mounted() {
            const today = new Date()
            const tomorrow = new Date(today)
            tomorrow.setDate(today.getDate() + 1)
            this.$nextTick(() => {
                const datePickerInput = $(this.$refs.datepicker)
                datePickerInput.datepicker({
                    ...this.datepickerOptions,
                    startDate: tomorrow
                })
                datePickerInput.on('changeDate', (e) => {
                    const selectedDate = e.date
                    if (selectedDate < tomorrow) {
                        datePickerInput.datepicker('setDate', tomorrow)
                        this.eventDate = moment(tomorrow).format('MM/DD/YYYY')
                    } else {
                        this.eventDate = moment(selectedDate).format('MM/DD/YYYY')
                    }
                })
            })
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .prev,
    .prev:hover {
        background-image: url(/images/prev-calendar.png) !important;
        background-position: left 50% top 24% !important;
        background-repeat: no-repeat !important;
        background-size: 12px !important;
        font-size: 0 !important;
    }
    .datepicker table tr td.day.focused,
    .datepicker table tr td.day:hover {
        background: #757575;
    }
    .next,
    .next:hover {
        background-image: url(/images/next-calendar.png) !important;
        background-position: right 50% top 24% !important;
        background-repeat: no-repeat !important;
        background-size: 12px !important;
        font-size: 0 !important;
    }
    .datepicker .datepicker-switch,
    .datepicker .next,
    .datepicker .prev,
    .datepicker tfoot tr th {
        color: #dedede;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 22px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.22px;
        text-transform: capitalize;
    }
    .datepicker-dropdown {
        border: 1px solid #464646 !important;
        border-radius: 15px;
        background: #464646;
        padding: 15px 25px;
    }
    .datepicker .datepicker-switch:hover,
    .datepicker .next:hover,
    .datepicker .prev:hover {
        background: transparent;
    }
    .dow {
        color: #dedede;
        text-align: center;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: 0.14px;
    }
    .day {
        color: #dedede;
        text-align: center;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: 0.14px;
    }
    .datepicker table tr td.new,
    .datepicker table tr td.old {
        color: #646464;
        text-align: center;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: 0.14px;
    }
</style>

<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .choose-date {
        color: #dedede;
        font-feature-settings: 'dlig' on, 'ss05' on, 'ss10' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 12px;
        font-style: normal;
        font-weight: 650;
        line-height: 135%;
        letter-spacing: 0.12px;
        margin: 0;
    }
    .date-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 6px;
    }
    .edit-title {
        color: #dedede;
        font-feature-settings: 'dlig' on, 'ss05' on, 'ss10' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 44px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
    }
    .edit-form-control {
        padding: 12px 16px 16px 16px;
        border-radius: 12px;
        border: 1px solid #8b8b8b;
        background: #262626;
        overflow: hidden;
        color: #646464;
        font-feature-settings: 'dlig' on, 'ss07' on, 'ss10' on, 'ss05' on, 'ss08' on, 'ss03' on;
        text-overflow: ellipsis;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .save-title-btn {
        display: inline-flex;
        padding: 11px 30px 12px 30px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        border-radius: 100px;
        background: #cdeb09;
        color: #000;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        width: 100%;
        border: 0;
    }
    .edit-title-form {
        gap: 34px;
    }
</style>

<style>
    .edit-form-control input::placeholder {
        color: #ffffff;
        font-size: 14px;
        font-family: 'Instrument Sans';
        line-height: 24px;
        letter-spacing: -0.14px;
    }
</style>
